import { i18n } from '@/i18n'

export const fieldTypeEmail = { type: 'email', message: i18n.tc('invalidEmail'), trigger: ['blur', 'change'] }
